import dayjs from 'dayjs';
import reportDao from '../../../../dao/reportDao';
import _isUndefined from 'lodash/isUndefined';
import {exampleData} from './components/exampleData';
import accountDao from '../../../../dao/accountDao';

const LOAD = 'pages/webmodule/reports/overview/LOAD';
const LOAD_SUCCESS = 'pages/webmodule/reports/overview/LOAD_SUCCESS';
const LOAD_EXAMPLE = 'pages/webmodule/reports/overview/LOAD_EXAMPLE';
const SET_REPORT_VIEWED = 'pages/webmodule/reports/overview/SET_REPORT_VIEWED';

const initialState = {
  sessions: {data: {}, loaded: false, loading: false},
  tryouts: {data: {}, loaded: false, loading: false},
  impressions: {data: {}, loaded: false, loading: false},
  isExampleData: false,
  reportViewed: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case LOAD:
      const newState1 = {...state};
      newState1[action.dataType].loading = true;
      newState1.isExampleData = false;
      return newState1;
    case LOAD_SUCCESS:
      const newState2 = {...state};
      newState2[action.dataType].loaded = true;
      newState2[action.dataType].data = action.result;
      return newState2;
    case LOAD_EXAMPLE:
      const newState3 = {...state};
      const data = exampleData();
      newState3.sessions.data = data.sessions.response;
      newState3.tryouts.data = data.tryouts.response;
      newState3.impressions.data = data.impressions.response;
      newState3.isExampleData = true;
      return newState3;
    case SET_REPORT_VIEWED:
      return {
        ...state,
        reportViewed: action.reportViewed,
      };
    default:
      return state;
  }
};

function load(dataType) {
  return {
    type: LOAD,
    dataType,
  };
}

function loadAsync(dataType) {
  return (dispatch, getState) => {
    dispatch(load(dataType));

    const reportType = {
      sessions: 'MODULE_SESSIONS',
      tryouts: 'TRY',
      impressions: 'IMPRESSIONS',
    };
    const params = {
      reportType: reportType[dataType],
      begin: dayjs()
        .subtract(4, 'week')
        .format('YYYY-MM-DD'),
      end: dayjs().format('YYYY-MM-DD'),
      granularity: 'week',
    };
    accountDao.queryEngagement().then(r => {
      dispatch(setReportViewed(r.reportViewed));
    });
    reportDao.listReport(params).then(json => {
      dispatch(loadSuccess(dataType, json));
      dispatch(loadExampleIfNeeded());
    });
  };
}

function loadExample() {
  return {
    type: LOAD_EXAMPLE,
  };
}

function loadExampleIfNeeded() {
  return (dispatch, getState) => {
    const sessions = getState().pages.webmodule.reports.overview.sessions;
    const tryouts = getState().pages.webmodule.reports.overview.tryouts;
    const isReportViewed = getState().pages.webmodule.reports.overview
      .reportViewed;
    const impressions = getState().pages.webmodule.reports.overview.impressions;
    const shouldLoadExample =
      !isReportViewed &&
      (sessions.loaded &&
        (_isUndefined(sessions.data.valid) || !sessions.data.valid.length) &&
        tryouts.loaded &&
        (_isUndefined(tryouts.data.valid) || !tryouts.data.valid.length) &&
        impressions.loaded &&
        (_isUndefined(impressions.data.valid) ||
          !impressions.data.valid.length));
    if (shouldLoadExample) {
      dispatch(loadExample());
    }
  };
}

function loadSuccess(dataType, result) {
  return {
    type: LOAD_SUCCESS,
    dataType,
    result,
  };
}

function shouldLoad(state, dataType) {
  const s = state.pages.webmodule.reports.overview[dataType];
  if (s.loaded) {
    return false;
  }
  if (s.loading) {
    return false;
  }
  return true;
}

export function loadIfNeeded(dataType) {
  return (dispatch, getState) => {
    if (shouldLoad(getState(), dataType)) {
      return dispatch(loadAsync(dataType));
    }
  };
}

export function reportOverviewForceLoad(dataType) {
  return dispatch => dispatch(loadAsync(dataType));
}

export function setReportViewed(reportViewed) {
  return {
    type: SET_REPORT_VIEWED,
    reportViewed,
  };
}
